import { render } from "./Datatable.vue?vue&type=template&id=51b08670&scoped=true"
import script from "./Datatable.vue?vue&type=script&lang=js"
export * from "./Datatable.vue?vue&type=script&lang=js"

import "./Datatable.vue?vue&type=style&index=0&id=51b08670&lang=scss&scoped=true"

import exportComponent from "/run/media/ctis-dev/developer/WorkSpaceFront/transparencia-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b08670"]])

export default __exports__